import ProductType from "../const/productType";
var isSecuredInstallment = function (accountType) {
    return accountType === ProductType.INSTALLMENT_LOAN_SECURED;
};
export default isSecuredInstallment;
//# sourceMappingURL=isSecuredInstallment.js.map